import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

import Tick from '../../icons/Tick.js';
import TickOutline from '../../icons/TickOutline.js';

export default ({ color, size, id, value, type, onChange, borderStyle }) => (
  <div
    className={classnames(styles.checkbox, {
      [styles.borderStyle]: borderStyle,
      [styles.checked]: value
    })}
  >
    <input
      className="a11y-hide"
      id={id}
      type={type}
      value={value}
      onChange={onChange}
    />
    {value ? (
      <Tick color={color} size={size} />
    ) : (
      <TickOutline color={color} size={size} />
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js